import { ArrowForward } from '@mui/icons-material';
import { ActionableButton } from '@renderer-ui-library/molecules';
import { Typography } from '@renderer-ui-library/mui';
import { BlockWrapper } from '@renderer-ui-library/scaffolding/BlockWrapper/BlockWrapper';
import { BlockProps } from 'blocks/BlockProps';
import { IPromoteServiceBlockData } from 'blocks/PromoteServiceBlock/IPromoteServiceBlockData';
import classnames from 'classnames';
import React from 'react';
import styles from './promoteServiceBlock.module.scss';

export const PromoteServiceBlock: React.FC<
    BlockProps<IPromoteServiceBlockData>
> = React.memo(({ data }) => {
    const buttonColor = data.darkBackground ? 'secondary' : 'primary';
    const buttonVariant = data.darkBackground ? 'contained' : 'text';

    return (
        <BlockWrapper blockData={data} noSpacingTop noSpacingBottom>
            <div
                className={classnames(styles.wrapper, {
                    [styles.darkBackground]: data.darkBackground,
                })}
            >
                <div className={styles.header}>
                    <div className={styles.headerContent}>
                        <Typography
                            variant="h4"
                            component="b"
                            color={data.darkBackground ? 'white' : 'primary'}
                        >
                            {data.title}
                        </Typography>
                    </div>
                    <div className={styles.desktopButton}>
                        <ActionableButton
                            noMinWidth
                            button={data.button}
                            variant={buttonVariant}
                            className={styles.button}
                            color={buttonColor}
                            endIcon={<ArrowForward />}
                        />
                    </div>
                </div>
                <div className={styles.subtitle}>
                    <Typography
                        variant="h5"
                        component="p"
                        fontWeight="inherit"
                        color={data.darkBackground ? 'white' : 'textSecondary'}
                    >
                        {data.description}
                    </Typography>
                </div>
                <div
                    className={classnames(styles.mobileButton, {
                        [styles.fullWidth]: data.darkBackground,
                    })}
                >
                    <ActionableButton
                        noMinWidth
                        button={data.button}
                        variant={buttonVariant}
                        className={styles.button}
                        color={buttonColor}
                        endIcon={<ArrowForward />}
                    />
                </div>
            </div>
        </BlockWrapper>
    );
});

PromoteServiceBlock.displayName = 'PromoteServiceBlock';
